var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { t } from 'i18next';
import React from 'react';
import { CompanyEnabledFeatureKeyType, RoleType } from 'common/types/server-api-dtos';
import { ChatsMenuSectionLink } from 'common/layouts/main-layout/modules/navigation/modules/chats-menu-section-link';
import { ApplicationsIcon, AwardsIcon, CartForMenuIcon, HomeIcon, HowIcon, OrgStructureIcon, PeopleIcon, ProfileIcon, RatingsIcon, SurpriseBoxMenuIcon, OneToOneIcon, CafeteriaBenefitsMenuIcon, MessagesMenuIcon, } from '../icons';
import { userService } from '../utils/user-service';
import { ROUTE_SEGMENTS } from '../routing';
export var getUserRoutes = function () { return [
    {
        path: ROUTE_SEGMENTS.HOME,
        index: true,
        icon: HomeIcon,
        title: t('common.routes.home'),
        isAdaptivePage: true,
        isShownInFooter: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/home'); }),
    },
    {
        path: ROUTE_SEGMENTS.CHATS,
        icon: MessagesMenuIcon,
        title: t('common.routes.messages'),
        isAdaptivePage: true,
        owner: RoleType.Basic,
        // FIX: remove true
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isChatsAvailable) || true; },
        checkIsShownInFooterMenu: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isChatsAvailable) || true; },
        customMenuSectionLink: ChatsMenuSectionLink,
        component: React.lazy(function () { return import('pages/user-pages/chat-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.SHOP,
        icon: CartForMenuIcon,
        title: t('common.routes.shop'),
        isAdaptivePage: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/place-market'); }),
        checkIsShownInFooterMenu: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isProductsAndOrdersEnabled); },
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isProductsAndOrdersEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.CAFETERIA_BENEFITS,
        icon: CafeteriaBenefitsMenuIcon,
        title: t('common.routes.cafeteriaBenefits'),
        isAdaptivePage: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/cafeteria-benefits'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isCafeteriaBenefitsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.INCOME_TEAL,
        icon: HowIcon,
        title: t('common.routes.incomeTeal'),
        isAdaptivePage: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/income-teal'); }),
        // FIX: remove false
        checkIsShownInFooterMenu: function (data) { var _a, _b; return !((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isChatsAvailable) && !!((_b = data.pageData) === null || _b === void 0 ? void 0 : _b.isActivitiesAndTealRequestsEnabled) && false; },
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isActivitiesAndTealRequestsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.PROFILE,
        icon: ProfileIcon,
        title: t('common.routes.profile'),
        isAdaptivePage: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/profile/profile-page'); }),
        checkIsShownInFooterMenu: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isProfileEnabled); },
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isProfileEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.SETTINGS_PROFILE,
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        title: t('common.routes.settingsProfile'),
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/profile/settings-profile-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.ADDRESS_BOOK,
        icon: PeopleIcon,
        isAdaptivePage: true,
        title: t('common.routes.addressBook'),
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/address-book/address-book-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isAddressBookEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.ADDRESS_BOOK_EMPLOYEE,
        title: t('common.routes.addressBook'),
        owner: RoleType.Basic,
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/user-pages/address-book/employee-info-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isAddressBookEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.ORGANIZATION_STRUCTURE,
        icon: OrgStructureIcon,
        isAdaptivePage: true,
        title: t('common.routes.orgStructure'),
        owner: RoleType.Basic,
        featureToggleKey: CompanyEnabledFeatureKeyType.OrganizationStructure,
        component: React.lazy(function () { return import('pages/user-pages/organization-structure'); }),
        checkAvailable: function (data) { var _a; return !!(((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isOrganizationStructureAvailable) && !data.screenData.isExceptDesktop); },
    },
    {
        path: ROUTE_SEGMENTS.TAKE_SURVEY,
        title: t('common.routes.surveys'),
        owner: RoleType.Basic,
        isNotIncludeInMenu: true,
        isAdaptivePage: true,
        component: React.lazy(function () { return import('pages/user-pages/take-survey'); }),
    },
    {
        path: ROUTE_SEGMENTS.MY_DEVELOPMENT,
        icon: OneToOneIcon,
        title: t('common.routes.developmentBlock'),
        owner: RoleType.Basic,
        isAdaptivePage: true,
        featureToggleKey: CompanyEnabledFeatureKeyType.MyDevelopment,
        component: React.lazy(function () { return import('pages/user-pages/development-block/my-development-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.myDevelopmentSectionEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.MY_EMPLOYEES_DEVELOPMENT,
        title: t('common.routes.developmentBlock'),
        owner: [RoleType.Supervisor, RoleType.AdminSupervisor],
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/user-pages/development-block/my-employees-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.AWARDS,
        icon: AwardsIcon,
        title: t('common.routes.awards'),
        owner: RoleType.Basic,
        isAdaptivePage: true,
        featureToggleKey: CompanyEnabledFeatureKeyType.Achievements,
        component: React.lazy(function () { return import('pages/user-pages/awards/awards-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.AWARD,
        icon: AwardsIcon,
        title: t('common.routes.awards'),
        owner: RoleType.Basic,
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        featureToggleKey: CompanyEnabledFeatureKeyType.Achievements,
        component: React.lazy(function () { return import('pages/user-pages/awards/detail-award-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.RATINGS,
        icon: RatingsIcon,
        isAdaptivePage: true,
        title: t('common.routes.rating'),
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/ratings'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isLeaderBoardEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.SURPRISE_BOXES,
        icon: SurpriseBoxMenuIcon,
        title: t('common.routes.surpriseBoxes'),
        owner: RoleType.Basic,
        isAdaptivePage: true,
        featureToggleKey: CompanyEnabledFeatureKeyType.SurpriseBoxes,
        component: React.lazy(function () { return import('pages/user-pages/surprise-boxes/surprise-boxes-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.showSurpriseBoxes); },
    },
    {
        path: ROUTE_SEGMENTS.SURPRISE_BOX,
        icon: SurpriseBoxMenuIcon,
        title: t('common.routes.surpriseBox'),
        owner: RoleType.Basic,
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        featureToggleKey: CompanyEnabledFeatureKeyType.SurpriseBoxes,
        component: React.lazy(function () { return import('pages/user-pages/surprise-boxes/surprise-box-detail-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.showSurpriseBoxes); },
    },
    {
        path: ROUTE_SEGMENTS.CREATE_ONE_TO_ONE,
        title: t('common.routes.createNewOneToOne'),
        isNotIncludeInMenu: true,
        owner: [RoleType.Supervisor, RoleType.AdminSupervisor],
        component: React.lazy(function () { return import('pages/user-pages/development-block/create-one-to-one-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.EDIT_ONE_TO_ONE,
        title: t('common.routes.updateOneToOne'),
        isNotIncludeInMenu: true,
        owner: [RoleType.Supervisor, RoleType.AdminSupervisor],
        component: React.lazy(function () { return import('pages/user-pages/development-block/edit-one-to-one-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.POST,
        title: t('common.routes.post'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/detail-post-pages/detail-post'); }),
    },
    {
        path: ROUTE_SEGMENTS.AWARD_POST,
        title: t('common.routes.award'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/detail-post-pages/detail-post'); }),
    },
    {
        path: ROUTE_SEGMENTS.ACTIVITY_ANNOUNCEMENT_POST,
        title: t('common.routes.activityAnnouncement'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/detail-post-pages/detail-activity-announcement-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.LEADER_POST,
        title: t('common.routes.leaders'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/detail-post-pages/detail-leader-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.BIRTHDAY_POST,
        title: t('common.routes.birthday'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/detail-post-pages/detail-birthday-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.RECOGNITION_POST,
        title: t('common.routes.gratitudePost'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/detail-post-pages/detail-gratitude-post'); }),
    },
    {
        path: ROUTE_SEGMENTS.RECOGNITION_SUPERVISOR_POST,
        title: t('common.routes.gratitudePost'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/detail-post-pages/detail-gratitude-post/detail-supervisor-post'); }),
    },
    {
        path: ROUTE_SEGMENTS.SURVEY_POST,
        title: t('common.routes.surveyPost'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/user-pages/detail-post-pages/detail-survey-post-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.CHAT,
        title: t('common.routes.chat'),
        isNotIncludeInMenu: true,
        isAdaptivePage: true,
        owner: RoleType.Basic,
        featureToggleKey: CompanyEnabledFeatureKeyType.AddressBookEnableChat,
        component: React.lazy(function () { return import('pages/user-pages/chat'); }),
    },
]; };
export var getSupervisorRoutes = function () { return [
    {
        path: ROUTE_SEGMENTS.SUPERVISOR_APPLICATIONS,
        icon: ApplicationsIcon,
        title: t('common.routes.supervisorApplications'),
        owner: RoleType.Supervisor,
        component: React.lazy(function () { return import('pages/supervisor-pages/applications'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isActivitiesAndTealRequestsEnabled); },
    },
]; };
export var getManagerRoutes = function () { return [
    {
        path: ROUTE_SEGMENTS.EMPLOYEES,
        title: t('common.routes.employees'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/employees/empoyees-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isEmployeesEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.EDIT_EMPLOYEE,
        title: t('common.routes.editEmployee'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/employees/edit-employee-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isEmployeesEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.APPLICATIONS,
        title: t('common.routes.applications'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/applications'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isActivitiesAndTealRequestsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.SETTINGS,
        title: t('common.routes.settings'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/settings/settings-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.CREATE_EMISSION,
        title: t('common.routes.createEmission'),
        isNotIncludeInMenu: true,
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/settings/create-emission-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.EDIT_EMISSION,
        title: t('common.routes.editEmission'),
        isNotIncludeInMenu: true,
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/settings/edit-emission-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.ORDERS,
        title: t('common.routes.orders'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/orders'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isProductsAndOrdersEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.ACTIVITIES,
        title: t('common.routes.activities'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/activities'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isActivitiesAndTealRequestsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.PRODUCTS,
        title: t('common.routes.products'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/products/products-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isProductsAndOrdersEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.CREATE_PRODUCT,
        title: t('common.routes.createProduct'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/products/create-product-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isProductsAndOrdersEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.EDIT_PRODUCT,
        title: t('common.routes.editProduct'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/products/edit-product-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isProductsAndOrdersEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.EDIT_CAFETERIA_BENEFITS,
        title: t('common.routes.editProduct'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/edit-cafeteria-benefit'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isCafeteriaBenefitsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.CREATE_AWARD,
        title: t('common.routes.createAward'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/awards/create-award-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.SURPRISE_BOXES_CREATE,
        title: t('common.routes.createSurpriseBox'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/surprise-boxes/create-surprise-box-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.SURPRISE_BOXES_EDIT,
        title: t('common.routes.editSurpriseBox'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/surprise-boxes/edit-surprise-box-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.EDIT_AWARD,
        title: t('common.routes.editAward'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/awards/edit-award-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.SURVEYS,
        title: t('common.routes.surveys'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/surveys/surveys-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.SELECT_SURVEY_TYPE,
        title: t('common.routes.surveys'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/surveys/select-survey-type-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.CREATE_SURVEY,
        title: t('common.routes.createSurvey'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/surveys/create-survey-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isOtherSurveysEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.EDIT_SURVEY,
        title: t('common.routes.editSurvey'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/surveys/edit-survey-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.SURVEY_RESULTS,
        title: t('common.routes.surveyResults'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/surveys/survey-results/survey-results-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.ENPS_SURVEY_RESULTS,
        title: t('common.routes.surveyResults'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/surveys/survey-results/enps-survey-results-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isOtherSurveysEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.SUPPORT_REQUESTS,
        title: t('common.routes.supportRequests'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/support-requests/support-requests-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isSupportRequestsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.SUPPORT_REQUEST,
        title: t('common.routes.supportRequests'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/support-requests/support-request-processing-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isSupportRequestsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.STATISTICS,
        title: t('common.routes.statistics'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/statistics/navigation-statistics-dashboard-page'); }),
    },
    {
        path: ROUTE_SEGMENTS.TEAM_STATISTICS,
        title: t('common.routes.statistics'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/statistics/team-statistics-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isStatisticsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.CORPORATE_CURRENCY_STATISTICS,
        title: t('common.routes.statistics'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/statistics/corporate-currency-statistics-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isCurrencyStatisticsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.ACTIVITIES_STATISTICS,
        title: t('common.routes.statistics'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/statistics/modular-analytics-activities-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isStatisticsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.SURVEYS_STATISTICS,
        title: t('common.routes.statistics'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/statistics/surveys-statistic-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isStatisticsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.REWARDS_STATISTICS,
        title: t('common.routes.statistics'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/statistics/modular-analytics-rewards-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isStatisticsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.GRATITUDES_STATISTICS,
        title: t('common.routes.statistics'),
        owner: RoleType.Manager,
        isNotIncludeInMenu: true,
        component: React.lazy(function () { return import('pages/manager-pages/statistics/modular-analytics-gratitudes-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isStatisticsEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.POST_CREATE,
        title: t('common.routes.createPost'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/posts/create-post'); }),
    },
    {
        path: ROUTE_SEGMENTS.POST_EDIT,
        title: t('common.routes.editPost'),
        isAdaptivePage: true,
        isNotIncludeInMenu: true,
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/manager-pages/posts/edit-post-page'); }),
    },
]; };
export var getAdminRoutes = function () { return [
    {
        path: ROUTE_SEGMENTS.USERS,
        title: t('common.routes.users'),
        // TODO: техдолг, подумать над скрытием пунктов меню по овнеру
        owner: RoleType.Admin,
        component: React.lazy(function () { return import('pages/admin-pages/users'); }),
        checkAvailable: function () { return userService.hasRole(RoleType.Admin); },
    },
    {
        path: ROUTE_SEGMENTS.BENEFIT_ADMIN,
        title: t('common.routes.benefitAdmin'),
        isNotIncludeInMenu: true,
        owner: RoleType.BenefitAdmin,
        component: React.lazy(function () { return import('pages/admin-pages/benefit'); }),
        checkAvailable: function () { return userService.hasRole(RoleType.BenefitAdmin); },
    },
]; };
export var getBasicRoutes = function () { return __spreadArray(__spreadArray(__spreadArray([], getSupervisorRoutes(), true), getManagerRoutes(), true), getAdminRoutes(), true); };
export var getRegistrationRoutes = function () { return [
    {
        path: ROUTE_SEGMENTS.REGISTRATION,
        title: t('common.routes.registration'),
        owner: RoleType.CompanyCreator,
        isAdaptivePage: true,
        component: React.lazy(function () { return import('pages/auth/registration-form'); }),
    },
]; };
export var getUserSelfRegistrationRoutes = function () { return [
    {
        path: ROUTE_SEGMENTS.REGISTRATION_COMPANY,
        isAdaptivePage: true,
        title: t('common.routes.fpkRegistration'),
        owner: RoleType.CompanyCreator,
        component: React.lazy(function () { return import('pages/auth/user-self-registration-form'); }),
    },
    {
        path: ROUTE_SEGMENTS.HR_CLUB_REGISTRATION,
        isAdaptivePage: true,
        title: t('common.routes.hrClubRegistration'),
        owner: RoleType.CompanyCreator,
        component: React.lazy(function () { return import('pages/auth/hr-club-registration-form'); }),
    },
]; };
export var getGuestRoutes = function () { return [
    {
        path: ROUTE_SEGMENTS.TAKE_SURVEY_LINK_ACCESS,
        title: t('common.routes.surveys'),
        owner: null,
        isAdaptivePage: true,
        component: React.lazy(function () { return import('pages/guest-pages/take-survey-guest'); }),
    },
    {
        path: ROUTE_SEGMENTS.PREVIEW_SURVEY,
        title: t('common.routes.previewSurvey'),
        owner: RoleType.Manager,
        component: React.lazy(function () { return import('pages/guest-pages/preview-survey-page'); }),
        checkAvailable: function (data) { var _a; return !!((_a = data.pageData) === null || _a === void 0 ? void 0 : _a.isOtherSurveysEnabled); },
    },
    {
        path: ROUTE_SEGMENTS.DOCS,
        title: t('common.routes.docs'),
        isAdaptivePage: true,
        owner: null,
        component: React.lazy(function () { return import('pages/guest-pages/docs-page'); }),
    },
]; };
export var getOpenPagesRoutes = function () { return [
    {
        path: ROUTE_SEGMENTS.CONFIDENTIAL,
        title: t('common.routes.confidential'),
        isAdaptivePage: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/open-pages/confidential'); }),
    },
    {
        path: ROUTE_SEGMENTS.COOKIES,
        title: t('common.routes.cookies'),
        isAdaptivePage: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/open-pages/cookies'); }),
    },
    {
        path: ROUTE_SEGMENTS.POLICY,
        title: t('common.routes.policy'),
        isAdaptivePage: true,
        owner: RoleType.Basic,
        component: React.lazy(function () { return import('pages/open-pages/policy'); }),
    },
]; };
export var getCompliancePagesRoutes = function () { return [
    {
        path: ROUTE_SEGMENTS.COMPLIANCE,
        title: t('common.routes.compliance'),
        isAdaptivePage: true,
        owner: [RoleType.Basic, RoleType.BenefitAdmin],
        component: React.lazy(function () { return import('pages/open-pages/compliance'); }),
    },
]; };
